var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneTelephone = function SvgPhoneTelephone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 25",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57 3.986a.98.98 0 0 1 .856.504l1.198 2.158a.981.981 0 0 1 .02.914L9.49 9.872s.334 1.72 1.734 3.12c1.4 1.4 3.114 1.727 3.114 1.727l2.31-1.154a.98.98 0 0 1 .913.02l2.164 1.204c.311.172.504.5.504.856v2.485c0 1.265-1.175 2.18-2.374 1.774-2.463-.83-6.286-2.413-8.709-4.836-2.423-2.422-4.005-6.245-4.836-8.707-.404-1.199.51-2.374 1.775-2.374H8.57Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};
export default SvgPhoneTelephone;